import { useState } from "react";
import AuthCard from "@/components/auth/AuthCard";
import AuthInput from "@/components/auth/AuthInput";
import AuthButton from "@/components/auth/AuthButton";
import AuthLink from "@/components/auth/AuthLink";
import { useAuth, formatAuthError } from "@/context/AuthContext";

export default function ResetRequest() {
  const { resetRequest } = useAuth();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await resetRequest(email.trim().toLowerCase());
      setSent(true);
    } catch (err) { setError(formatAuthError(err)); }
    finally { setBusy(false); }
  };

  return (
    <AuthCard
      title="Reset your password"
      subtitle={sent ? "Check your inbox" : "Enter your email to receive a reset link"}
      footer={<AuthLink to="/auth/login" testid="reset-req-back-login">Back to login</AuthLink>}
    >
      {sent ? (
        <p className="text-xs text-center" style={{ color: "#a8dca8" }} data-testid="reset-req-sent">
          If an account exists for <strong>{email}</strong>, we sent a reset link. It expires in 10 minutes.
        </p>
      ) : (
        <form onSubmit={onSubmit}>
          <AuthInput label="Email" type="email" required
            testid="reset-req-input-email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com" autoComplete="email"
            error={error} />
          <AuthButton type="submit" testid="reset-req-submit" loading={busy}>Send reset link</AuthButton>
        </form>
      )}
    </AuthCard>
  );
}
